import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-admin-notice-preview',
  templateUrl: './admin-notice-preview.component.html',
  styleUrls: ['./admin-notice-preview.component.css']
})
export class AdminNoticePreviewComponent implements OnChanges {

  @Input()
    notice:any;

  @Output()
    previewToggle:EventEmitter<boolean> =new EventEmitter();

    contents:Array<String>=[];
    files:Array<String>=[];

  date:Date =new Date();

  
  constructor() { }

  ngOnInit(): void {

  }

  ngOnChanges():void{
    this.contents = this.notice.content.split('\n'); this.files = this.notice.file.split('\n');}

  unactivePreivew(){
    this.previewToggle.emit(false);
  }

}
